// components/MessageModal.jsx
import { useState, useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";

export default function MessageModal({ isOpen, onClose }) {
  const { messages, fetchWithAuth, setHasUnacknowledgedMessages } = useAuth();
  const [ackIndex, setAckIndex] = useState(0);

  const hasMessages = messages.length > 0;
  const current = messages[ackIndex];

  useEffect(() => {
    if (!isOpen) setAckIndex(0); // reset when modal closes
  }, [isOpen]);

  if (!isOpen || !hasMessages) return null;

  const handleAcknowledge = async () => {
    try {
      await fetchWithAuth(`/api/messages/${current.id}/acknowledge`, {
        method: "POST",
      });

      if (ackIndex < messages.length - 1) {
        setAckIndex(prev => prev + 1);
      } else {
        setHasUnacknowledgedMessages(false);
        onClose(); // close modal after last message
      }
    } catch (err) {
      console.error("Failed to acknowledge message:", err);
      alert("Error acknowledging message. Please try again.");
    }
  };

  return (
      <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
        <div className="bg-white p-6 rounded-lg max-w-md w-full shadow-lg text-center">
          <h2 className="text-xl font-bold mb-4">{current.title}</h2>
          <p className="mb-6">{current.content}</p>
          <button
              className="bg-[#F29E38] text-white px-6 py-2 rounded hover:bg-[#e6891c]"
              onClick={handleAcknowledge}
          >
            Acknowledge
          </button>
        </div>
      </div>
  );
}
